import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: false,
            showVariant: false,
            showPackage: false,
            showStartDateWithTime: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
        },
        showLinkedCards: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
